module.exports = __webpack_public_path__ + "static/media/repair.5e3296f6.png";